import type { FC, PropsWithChildren } from 'react';

import { Services_Body } from '@/pages/services/_body';
import TemplateService from '@/template/service';

import {
  bannerBlock,
  pageContentBlock,
} from '@/styles/components/blocks.module.scss';
import {
  h1 as subtitle,
  h2 as title,
} from '@/styles/components/titles.module.scss';

type TProps = {
  title: string;
  subtitle: string;
  paragraphs?: (string | JSX.Element)[];
};

export const AddOnsTemplate: FC<
  PropsWithChildren<TProps>
> = ({ children, paragraphs = [], ...props }) => {
  return (
    <TemplateService>
      <div className={pageContentBlock}>
        <div className={bannerBlock}>
          <h1 className={title}>{props.title}</h1>
          <h2 className={subtitle}>{props.subtitle}</h2>
        </div>

        <Services_Body>
          {children}
          {paragraphs.map((value, index) => (
            <p key={`${index}`}>{value}</p>
          ))}
        </Services_Body>
      </div>
    </TemplateService>
  );
};
